<template>
	<Layout :loading="loading" :pageTitle="'Membresías'">
		<template #cta>
			<router-link tag="a" to="/memberships/create" class="btn btn-primary">Crear membresía</router-link>
		</template>

		<template #bar>
			<div class="filters-box justify-content-between">
				<div class="filter">
					<div class="filter-input">
						<i class="icon icon-search"></i>
						<input
							type="text"
							class="form-control"
							placeholder="Buscar en membresías"
							v-model="filters.search"
							@keyup.enter="updateFilters($event)"
						/>
						<div
							class="btn btn-light btn-clear-filter"
							v-if="filters.search"
							@click="
								filters.search = null
								updateFilters()
							"
						>
							<i class="icon icon-close"></i>
						</div>
					</div>
				</div>
			</div>
		</template>

		<template #head>
			<div>
				<ul class="nav nav-tabs border-none">
					<li class="nav-item">
						<router-link
							tag="a"
							:to="`/memberships?status=active`"
							:class="{ active: !filters.status || filters.status == 'active' }"
							class="nav-link"
							>Activas</router-link
						>
					</li>
					<li class="nav-item">
						<router-link
							tag="a"
							:to="`/memberships?status=inactive`"
							:class="{ active: filters.status == 'inactive' }"
							class="nav-link"
							>Inactivas</router-link
						>
					</li>
				</ul>
			</div>
		</template>

		<Loader :show="loading" type="inline" />

		<div class="main-container container p-3" v-if="!loading">
			<router-link
				tag="div"
				:to="`${$route.path}/${item.id}`"
				v-for="item of list"
				:key="item.id"
				class="card mb-3"
			>
				<div class="card-body">
					<div class="event-item" :class="{ 'sold-out': !item.canBuy && !item.hasTicketsAvailable }">
						<div class="sold-out" v-if="!item.canBuy && !item.hasTicketsAvailable">SOLD OUT</div>

						<div
							class="image"
							v-if="item && item.image"
							:style="`background-image: url(${item.image.url})`"
						></div>
						<div class="data">
							<h2>{{ item.name }}</h2>
							<p class="text-secondary">
								Disponibles hasta: {{ item.validAt | moment("ddd DD MMM YYYY HH:mm") }}
								<br />

								<strong>{{ item.currencySymbol }} {{ item.price | toCurrency }}</strong>
							</p>
							<div class="badge" :class="`badge-${item.statusClass}`">{{ item.statusText }}</div>
						</div>
						<div class="stats">
							<b-progress :max="100" height="6px">
								<b-progress-bar :value="item.soldPercent" variant="success"></b-progress-bar>
							</b-progress>

							<div class="d-flex justify-content-between">
								<div>
									<h5>{{ item.sold }} vendidas</h5>
									<span class="text-secondary">de {{ item.limit }}</span>
								</div>
								<div class="text-right">
									<h5>{{ item.currencySymbol }} {{ item.totalSales | toCurrency }}</h5>
									<span class="text-secondary">ventas netas</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</router-link>

			<div class="mt-3">
				<Pagination :pageData="pagination" @pageChange="pageChange" @pageLength="pageLength" />
			</div>

			<div class="card" v-if="list.length <= 0">
				<div class="card-body text-center py-4">
					<h5>Ofrece membresias ...</h5>
					<p>...........</p>
					<router-link tag="a" to="/memberships/create" class="btn btn-primary mt-2"
						>Crear membresia</router-link
					>
				</div>
			</div>
		</div>
	</Layout>
</template>

<script>
import gql from "graphql-tag"

export default {
	name: "Memberships",
	data() {
		return {
			list: [],
			loading: true
		}
	},
	beforeMount() {
		this.filters = this.getValidUrlParams()
		this.load()
	},
	methods: {
		load() {
			this.loading = true
			this.$apollo
				.query({
					query: gql`
						query($take: Int, $skip: Int, $search: String, $status: String) {
							membershipTypes(take: $take, skip: $skip, search: $search, status: $status) {
								data {
									id
									name
									validAt
									currencySymbol
									price
									limit
									sold
									soldPercent
									totalSales
									canBuy
								}
								pageInfo {
									totalItems
								}
							}
						}
					`,
					variables: {
						take: this.pagination.length,
						skip: this.pagination.skip,
						search: this.filters.search,
						status: this.filters.status ? this.filters.status : "all"
					},
					fetchPolicy: "network-only"
				})
				.then(({ data }) => {
					this.list = data.membershipTypes.data
					this.pagination.pageInfo = data.membershipTypes.pageInfo
					this.loading = false
				})
				.catch(() => {
					this.loading = false
				})
		}
	}
}
</script>

<style scoped lang="scss">
.card {
	overflow: hidden;
}
.event-item {
	display: flex;
	align-items: center;
	padding: 10px;
	cursor: pointer;
	position: relative;

	.sold-out {
		position: absolute;
		top: 8px;
		left: -31px;
		background: red;
		color: #fff;
		transform: rotate(-45deg);
		padding: 0px 20px;
		font-size: 0.74rem;
	}

	&.sold-out {
		opacity: 0.75;
	}

	.image {
		width: 82px;
		height: 82px;
		border-radius: 4px;
		background-color: #eee;
	}

	.data {
		flex: 1;
		padding-left: 12px;

		h2 {
			margin-bottom: 0px;
			font-weight: 700;
			font-size: 18px;
			line-height: 24px;
		}
		p {
			padding: 0px;
			margin: 0px;
		}
	}
	.stats {
		flex-grow: 1;

		h5 {
			font-size: 15px;
			margin-top: 10px;
			line-height: 12px;
		}
	}
}
</style>
